module.exports = __webpack_public_path__ + "static/media/icon-event-place.82589022.svg";